import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import {
  ROUTE_CALCULATORS_FORWARD_CURVE_NEW,
  ROUTE_CALCULATORS_BANK_SWAP,
  ROUTE_CALCULATORS_PREPAYMENT,
  ROUTE_CALCULATORS_CAP_PRICER,
  ROUTE_CALCULATORS_LOAN_PROCEEDS,
  ROUTE_CALCULATORS_AMORTIZATION,
  ROUTE_CALCULATORS_YIELD_CURVES,
  ROUTE_CALCULATORS_TEST_HARNESS,
  ROUTE_CALCULATORS_CASHFLOWS
} from "constants/routes";
import PrivateRoute from "components/PrivateRoute";
import {
  Grid,
  List,
  Drawer,
  ListItem,
  ListItemText
} from "@material-ui/core";
import {
  showBankSwapModal,
  hideBankSwapModal
} from "store/state/modals/bankSwapEdit";
import { getForwardCurve } from "store/state/calculators/forwardCurve";
import BreadCrumbGrid from "components/Global/BreadCrumb/BreadCrumbGrid";
import { compose } from "recompose";

import ForwardCurveNew from "./ForwardCurveNew";
import SwapCalculator from "./BankSwap/SwapCalculator";
import Prepayment from "./Prepayment";
import CapPricer from "./CapPricer";
import LoanProceeds from "./LoanProceeds";
import Amortization from "./Amortization";
import YieldCurves from "./YieldCurves";
import { TestHarness } from "./TestHarness";
import Cashflows from "./Cashflows";

const styles = () => ({
  drawerPaper: {
    position: "relative",
    background: "#f5f5f5",
    zIndex: 300,
    height: "100%"
  }
});

const CalculatorWrapper = styled(Grid)`
  && {
    height: 100%;
  }
`;
const Frame = styled.div`
  display:flex;
  width:100%;
  height:100%;
`;
const SelectedListItem = styled(ListItem)`
  border-left: 8px solid #2196f3;  
  && {    
    background: #fff;
    padding-left:16px;
  }
`;
const CalculatorList = styled(List)`
  &&& {            
    padding-top:1px;    
  }
`;
const StyledTitle = styled.div`
  padding-top:10px;
  margin-left:24px;
`;
const SideBar = styled(Grid)`
  background:#f5f5f5;  
`;
const ListItemLink = ({ to, text, currentLocation }) => {
  const isSelected = to === currentLocation.pathname;
  const children = (
    <NavLink
      exact
      to={to}
    >
      <ListItemText>{text}</ListItemText>
    </NavLink>
  );

  return isSelected ? (<SelectedListItem>{children}</SelectedListItem>) : (<ListItem>{children}</ListItem>);
};

const Calculators = props => {
  const { location, classes, authentication } = props;

  const SystemAdminOnlyLinks = () => (
    <>
      <ListItemLink
        to="/calculators/yieldCurves"
        currentLocation={location}
        text="Yield Curves"
      />
      <ListItemLink
        to="/calculators/amortization"
        currentLocation={location}
        text="Amortization"
      />
      <ListItemLink
        to="/calculators/testHarness"
        currentLocation={location}
        text="Test Harness"
      />
      <ListItemLink
        to={ROUTE_CALCULATORS_CASHFLOWS}
        currentLocation={location}
        text="Cashflows"
      />
    </>
  );

  return (
    <>
      <BreadCrumbGrid>
        <StyledTitle>Calculators</StyledTitle>
      </BreadCrumbGrid>
      <Frame>
        <Drawer
          variant="permanent"
          classes={{ paper: classes.drawerPaper }}
          anchor="left"
        >
          <CalculatorList>
            <ListItemLink
              to="/calculators/bankSwap"
              currentLocation={location}
              text="Bank Swap"
            />
            <ListItemLink
              to="/calculators/loanProceeds"
              currentLocation={location}
              text="Loan Proceeds"
            />
            {authentication.isSystemAdmin && <SystemAdminOnlyLinks />}

          </CalculatorList>
        </Drawer>
        <CalculatorWrapper container alignItems="stretch">
          <Grid item xs={12}>
            <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={ROUTE_CALCULATORS_FORWARD_CURVE_NEW} Component={ForwardCurveNew} />
            <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={ROUTE_CALCULATORS_BANK_SWAP} Component={SwapCalculator} />
            <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={ROUTE_CALCULATORS_PREPAYMENT} Component={Prepayment} />
            <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={ROUTE_CALCULATORS_CAP_PRICER} Component={CapPricer} />
            <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={ROUTE_CALCULATORS_LOAN_PROCEEDS} Component={LoanProceeds} />
            <PrivateRoute systemAdmin authentication={authentication} path={ROUTE_CALCULATORS_YIELD_CURVES} Component={YieldCurves} />
            <PrivateRoute systemAdmin authentication={authentication} path={ROUTE_CALCULATORS_AMORTIZATION} Component={Amortization} />
            <PrivateRoute systemAdmin authentication={authentication} path={ROUTE_CALCULATORS_TEST_HARNESS} Component={TestHarness} />
            <PrivateRoute systemAdmin authentication={authentication} path={ROUTE_CALCULATORS_CASHFLOWS} Component={Cashflows} />
          </Grid>
        </CalculatorWrapper>
      </Frame>
    </>
  );
};

const mapStateToProps = ({
  authentication,
  forwardCurve
}) => ({
  authentication,
  forwardCurve
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    {
      getForwardCurve,
      showBankSwapModal,
      hideBankSwapModal
    }
  )
)(Calculators);
